import { charityConstants } from "../constants/charityConstants";

const initialState = {
  sending: false,
  charityResponse: {},
  charityList: {},
  deleteStatus: {},
  status: {},
  detail: {},
  error: {},
};

export default function charityReducer(state = initialState, action) {
  switch (action.type) {
    case charityConstants.ADD_CHARITY_REQUEST:
      return {
        sending: true
      };
    case charityConstants.ADD_CHARITY_SUCCESS:
      return {
        ...state,
        charityResponse: action.data
      };
    case charityConstants.ADD_CHARITY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case charityConstants.GET_CHARITY_REQUEST:
      return {
        sending: true
      };
    case charityConstants.GET_CHARITY_SUCCESS:
      return {
        ...state,
        charityList: action.data
      };
    case charityConstants.GET_CHARITY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case charityConstants.DELETE_CHARITY_REQUEST:
      return {
        sending: true
      };
    case charityConstants.DELETE_CHARITY_SUCCESS:
      return {
        ...state,
        deleteStatus: action.data
      };
    case charityConstants.DELETE_CHARITY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case charityConstants.STATUS_CHARITY_REQUEST:
      return {
        sending: true
      };
    case charityConstants.STATUS_CHARITY_SUCCESS:
      return {
        ...state,
        status: action.data
      };
    case charityConstants.STATUS_CHARITY_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case charityConstants.GET_CHARITYDETAIL_REQUEST:
      return {
        sending: true
      };
    case charityConstants.GET_CHARITYDETAIL_SUCCESS:
      return {
        ...state,
        detail: action.data
      };
    case charityConstants.GET_CHARITYDETAIL_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/charityReducer.js